import React, { useCallback, useEffect } from "react";
import BinIcon from "../../components/icon/Icon";
import { useDispatch, useSelector } from "react-redux";
import {
    getLiteTradeMarketFavoriteInProgress,
    makeSelectLiteTradeFilteredCollectionByKey
} from "../LiteTrade/liteTradeSelectors";
import _ from "lodash";
import { COLLECTION_KEYS } from "../../mobileAppCore/components/MobileMarket/mobileMarketConstants";
import { updateLiteTradeMarketFavoriteAssetAction } from "../LiteTrade/liteTradeActions";

interface ISymbolFavoriteProps {
    symbol: string,
}

function SymbolFavorite(props: ISymbolFavoriteProps) {
    const {
        symbol,
    } = props;
    const dispatch = useDispatch();
    const collection = useSelector(makeSelectLiteTradeFilteredCollectionByKey(COLLECTION_KEYS.FAVORITES));
    const marketFavoriteInProgress = useSelector(getLiteTradeMarketFavoriteInProgress);
    const [isActive, setIsActive] = React.useState(false);

    useEffect(() => {
        setIsActive(!!_.find(collection?.assets, { symbol }));
    }, [collection, symbol]);

    const clickHandler = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (marketFavoriteInProgress) {
            return;
        }
        setIsActive(state => !state);
        dispatch(updateLiteTradeMarketFavoriteAssetAction({
            active: !isActive,
            symbol,
        }))
    }, [marketFavoriteInProgress, dispatch, isActive, symbol]);

    return <>
        <BinIcon name={isActive ? 'IcBookmarkFilled' : 'IcBookmark'}
                 onClick={clickHandler}/>
    </>
}

export default SymbolFavorite;
